import React, { useState } from "react";

/**
 * LazyImage — drop-in <img> replacement with shimmer placeholder and fade-in on load.
 * Uses native loading="lazy" + decoding="async" for deferred network fetch.
 * Shimmer placeholder holds layout space until image loads, then fades out.
 */
export default function LazyImage({
  src,
  alt = "",
  className = "",
  style = {},
  width,
  height,
  objectFit = "cover",
  objectPosition = "center center",
}) {
  const [loaded, setLoaded] = useState(false);

  const sizeStyle = {
    width: width || "100%",
    height: height || "100%",
  };

  return (
    <div style={{ position: "relative", overflow: "hidden", ...sizeStyle }}>
      {/* Shimmer placeholder — visible until image loads */}
      {!loaded && (
        <div
          className="ecl-skeleton"
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: "inherit",
          }}
        />
      )}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        className={className}
        onLoad={() => setLoaded(true)}
        style={{
          width: "100%",
          height: "100%",
          objectFit,
          objectPosition,
          display: "block",
          opacity: loaded ? 1 : 0,
          transition: "opacity 220ms cubic-bezier(0.16, 1, 0.3, 1)",
          ...style,
        }}
      />
    </div>
  );
}
